module.exports = __webpack_public_path__ + "img/terroir-4-mobile.d423b81f.jpg";